import { useMemo } from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import FeaturedTable from '../FeaturedTable/FeaturedTable'
import ConfirmPopup from '../Popups/ConfirmPopup'

import prepareCell from './prepareCellComponent'
import { prepareOptions, daysLong } from './helper'

const OnCallScheduleTab = ({
  handleSubmit,
  values,
  setFieldValue,
  setValues,
  initialValues,
  isConfirmPopupVisible,
  setConfirmPopupVisible,
  staffPeople,
  propertyManagers,
  shiftManagers,
}) => {
  const { t } = useTranslation(['on-call-schedule', 'common'])
  const options = useMemo(
    () => [
      {
        label: t('on-call-schedule:groupLabels.maintenance'),
        options: prepareOptions(staffPeople),
      },
      {
        label: t('on-call-schedule:groupLabels.propertyManager'),
        options: prepareOptions(propertyManagers),
      },
      {
        label: t('on-call-schedule:groupLabels.frontDesk'),
        options: prepareOptions(shiftManagers),
      },
    ],
    [propertyManagers, shiftManagers, staffPeople, t],
  )

  return (
    <div className="on-call-schedule__tab-content on-call-schedule__tab-content__box">
      <form onSubmit={handleSubmit}>
        <FeaturedTable
          columns={[
            {
              Header: '',
              accessor: 'day',
            },
            {
              Header: t('on-call-schedule:table.businessHours'),
              accessor: 'BH',
              Cell: prepareCell({ options, values, setFieldValue }),
            },
            {
              Header: t('on-call-schedule:table.afterBusinessHours'),
              accessor: 'OutOfBH',
              Cell: prepareCell({ options, values, setFieldValue }),
            },
          ]}
          data={daysLong.map((item, index) => ({ ...item, id: index }))}
        />
        <div className="on-call-schedule__buttons">
          <button
            className="on-call-schedule__buttons--cancel"
            type="reset"
            onClick={() => setValues(initialValues)}
          >
            {t('common:actions.cancel')}
          </button>
          <button className="on-call-schedule__buttons--submit" type="submit">
            {t('common:actions.save')}
          </button>
        </div>
        <ConfirmPopup
          title={t('on-call-schedule:confirmLeave.title')}
          body={t('on-call-schedule:confirmLeave.body')}
          cancelText={t('on-call-schedule:confirmLeave.cancelText')}
          confirmText={t('on-call-schedule:confirmLeave.confirmText')}
          isOpen={isConfirmPopupVisible}
          cancelCallback={() => setConfirmPopupVisible(false)}
          confirmCallback={() => {
            setConfirmPopupVisible(false)
            setValues(initialValues)
          }}
          className={'is-caution'}
        />
      </form>
    </div>
  )
}

OnCallScheduleTab.propTypes = {
  handleSubmit: PropTypes.func,
  values: PropTypes.object.isRequired,
  setFieldValue: PropTypes.func,
  setValues: PropTypes.func,
  isConfirmPopupVisible: PropTypes.bool,
  setConfirmPopupVisible: PropTypes.func,
  shiftManagers: PropTypes.array,
  propertyManagers: PropTypes.array,
  staffPeople: PropTypes.array,
  initialValues: PropTypes.object,
}

export default OnCallScheduleTab
